import { render, staticRenderFns } from "./BackdropCard.vue?vue&type=template&id=faf3b9f6&scoped=true&"
import script from "./BackdropCard.vue?vue&type=script&lang=js&"
export * from "./BackdropCard.vue?vue&type=script&lang=js&"
import style0 from "./BackdropCard.vue?vue&type=style&index=0&id=faf3b9f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf3b9f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
